<template>
  <!-- 底部公共组件 -->
  <div>
    <div class="footer">
      <!-- footerTop
        <div class="footerTop">
          <p>简动云客，为您打造智能健身提供专业的解决方案</p>
          <button>免费试用</button>
        </div> -->
      <!-- footerBottom -->
      <div class="footerBottom">
        <div class="footerBottomInfo">
          <div class="infoBox">
            <el-row :gutter="10">
              <!-- <el-col :xs="24" :sm="5">
                <div class="left">
                  <div class="descTitle">快速导航</div>
                  <div class="navList">
                    <el-row :gutter="10">
                      <el-col :xs="6" :sm="24">
                        <div class="nav" @click="navBtn(1)">简动APP</div>
                      </el-col>
                      <el-col :xs="6" :sm="24">
                        <div class="nav" @click="navBtn(2)">简动云客</div>
                      </el-col>
                      <el-col :xs="6" :sm="24">
                        <div class="nav" @click="navBtn(3)">关于我们</div>
                      </el-col>
                      <el-col :xs="6" :sm="24">
                        <div class="nav" @click="navBtn(4)">免费试用</div>
                      </el-col>
                      <el-col :xs="0" :sm="24">
                        <div class="nav" @click="navBtn(5)">云客登录</div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col> -->
              <el-col :xs="24" :sm="18">
                <div class="center">
                  <div class="descTitle">联系我们</div>
                  <div class="desc">
                    <span>客服电话：400-889-0766</span>
                  </div>
                  <div class="desc">hbry@hbry.com</div>
                  <div class="desc">
                    联系地址：河北省石家庄市桥西区庄家金融大厦902-1
                  </div>
                </div>
              </el-col>
              <el-col :xs="0" :sm="6">
                <div class="right">
                  <div class="descTitle">官方服务</div>
                  <div class="serveInfo">
                    <div class="imgBox">
                      <img
                        src="@/assets/aaa.png"
                        width="100"
                        height="100"
                        alt=""
                      />
                      <div class="imgDesc">
                        <span>官方公众号</span>
                      </div>
                    </div>
                    <div class="imgBox">
                      <img
                        src="@/assets/aaa.png"
                        width="100"
                        height="100"
                        alt=""
                      />
                      <div class="imgDesc">
                        <span>商家服务</span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="company" style="padding-bottom: 0">
            <a
              target="_blank"
              href="https://beian.miit.gov.cn"
              style="color: #999"
              >版权所有 @ 河北睿银金融服务外包有限公司</a
            >
          </div>
          <div class="company">
            <div style="width: 300px; margin: 0 auto; padding: 0 0">
              <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo"
                style="
                  display: inline-block;
                  text-decoration: none;
                  height: 20px;
                  line-height: 20px;
                "
                ><img src="@/assets/gongan.png" style="float: left" />
                <p
                  style="
                    float: left;
                    height: 20px;
                    line-height: 20px;
                    margin: 0px 0px 0px 5px;
                    color: #939393;
                  "
                >
                  冀ICP备18005534号-1
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  component: {},
  created() {
    // console.log(this.headNavState);
  },
  methods: {
    //  导航点击事件
    navBtn(rows) {
      let state = 1;
      switch (rows * 1) {
        case 1: //简动
          if (this.headNavState != 1) {
            this.$router.push("/jianSport");
            state = 1;
          }

          break;
        case 2: //云客
          if (this.headNavState != 2) {
            this.$router.push("/ykSport");
            state = 2;
          }

          break;
        case 3: //关于我们
          if (this.headNavState != 3) {
            this.$router.push("/AboutUs");
            state = 3;
          }

          break;
        case 4: //免费试用
          if (this.headNavState != 4) {
            this.$router.push("/freeTrial");
            state = 4;
          }

          break;
        default:
          //免费试用
          window.open(
            "https://www.jiansport.com/veSass/dist/index.html#/login"
          );
          break;
      }
      this.$store.dispatch("tm_headNavStateBtn", state);
    },
  },
};
</script>
<style lang="less" scoped>
.footerBottom {
  width: 100%;
  margin-top: 100px;
  overflow: hidden;
  min-height: 406px;
  background: #1b2028;

  .footerBottomInfo {
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.4);
    font-size: 16px;
    line-height: 16px;

    .infoBox {
      width: 100%;
      overflow: hidden;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      padding: 57px 20px 30px 20px;
      box-sizing: border-box;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;

      // .center{margin-right:202px;}
      .descTitle {
        padding-bottom: 40px;
        font-size: 20px;
        line-height: 20px;
        color: #ffffff;
      }

      .nav {
        padding-bottom: 24px;
        cursor: pointer;

        &:hover {
          color: #ffffff;
        }
      }

      .desc {
        padding-bottom: 24px;
        line-height: 24px;
      }

      .serveInfo {
        display: flex;
        display: -webkit-flex;
        justify-content: space-around;
        align-items: center;
      }

      .imgBox {
        width: 100px;
        overflow: hidden;

        &:nth-of-type(1) {
          margin-right: 40px;
        }

        img {
          display: block;
        }

        .imgDesc {
          text-align: center;
          padding: 20px 0;
        }
      }
    }

    .company {
      width: 100%;
      text-align: center;
      line-height: 24px;
      padding: 20px 20px;
      box-sizing: border-box;
    }
  }
}

.el-row {
  max-width: 1200px;
  width: 100%;
}

@media screen and(max-width:750px) {
  .footerBottom {
    min-height: auto;

    .company {
      font-size: 14px;
    }
  }

  .footerBottom .footerBottomInfo .infoBox {
    padding: 30px 20px 20px;
    box-sizing: border-box;

    .left {
      .descTitle {
        padding-bottom: 20px;
        box-sizing: border-box;
      }

      .nav {
        padding-bottom: 10px;
      }
    }

    .center {
      div {
        padding-bottom: 10px;
        box-sizing: border-box;
      }

      .descTitle {
        padding: 20px 0;
        box-sizing: border-box;
      }
    }

    .right {
      .descTitle {
        padding: 20px 0;
        box-sizing: border-box;
      }

      .serveInfo {
        margin-top: 20px;
      }
    }
  }
}
</style>
